import React from 'react'
import ContactUsAppLink from './ContactUsAppLink'
import ContactUsForm from './ContactUsForm'
import ContactInquiry from './ContactInquiry/ContactInquiry'

const ContactUsPage = () => {
  return (
    <>
    <ContactUsAppLink />
    <ContactInquiry />
    <ContactUsForm />
    </>
  )
}

export default ContactUsPage